import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';
import { buttonVariants } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

/** Page of a section the role cannot open (the API refuses it anyway: RBAC docs/08 §6). */
export function ForbiddenPage() {
  return (
    <EmptyState
      icon={ShieldAlert}
      titleAs="h1"
      title="Accesso non consentito"
      description="Il tuo ruolo non può aprire questa sezione. Se ti serve, chiedi a un responsabile FMF."
      action={
        <Link to="/" className={buttonVariants()}>
          Torna al cruscotto
        </Link>
      }
    />
  );
}
